import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { getOne, create } from './../../../../common/v4/BackendProvider';
import { EditPage, EditPagePanel, EditPageTextField, EditPageSelect, EditPageCheckbox } from './../../../../common/EditPage';

import { ToastContainer, toast } from 'react-toastify';

const CarrierVoiceAccountsCreateIngress = () => {
     const [data, setData] = useState({
        ATRDIRECTION: 2, 
    });
    const [metadata, setMetadata] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const carrierId = useParams().carrier_id;
    const navigate = useNavigate();

    useEffect(() => {
        getOne(`/admin/carriers/carriers/${carrierId}/voiceaccounts/`, 'new_ingress')
            .then(response => {
                setMetadata(response.data.metadata);
            }).catch(error => {
                toast.error("Error fetching carrier: " + error.message, {});
            });
    }, [carrierId]);

    const handleSave = () => {
        create(`/admin/carriers/carriers/${carrierId}/voiceaccounts`, {data: data}).then(response => {
            toast.success("Carrier created successfully", {});
            navigate(`/carriers/carriers/${carrierId}/voiceaccounts`);
        }).catch(error => {
            toast.error("Error creating carrier: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate(`/carriers/carriers/${carrierId}/voiceaccounts`);
    };

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } >
                <EditPagePanel>
                    <EditPageSelect label="Authentication Type" id="ATRAUTHTYPEID" onChange={ onChange } value={ data.ATRAUTHTYPEID } options={ metadata?.auth_types?.values } />
                    <EditPageTextField label="Name" id="ATRALIAS" onChange={ onChange } value={ data.ATRALIAS } />
                    <EditPageTextField label="IP Address" id="ATRIPADDR" onChange={ onChange } value={ data.ATRIPADDR } />
                    <EditPageTextField label="Port" id="port" onChange={ onChange } value={ data.port } />
                    <EditPageTextField label="Prefix" id="ATRPREFIX" onChange={ onChange } value={ data.ATRPREFIX } />
                    <EditPageSelect label="Rate Profile" id="ATRPRODUCTID" onChange={ onChange } value={ data.ATRPRODUCTID } options={ metadata?.products?.values } />
                    <EditPageCheckbox label="Enabled" id="ATRSTATUS" onChange={ onChange } value={ data.ATRSTATUS } />
                </EditPagePanel>
            </EditPage>
        </>
    )
}

export default CarrierVoiceAccountsCreateIngress;